// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1FOyp","errorLogs":"EditorFooter_errorLogs__1lCjO"};